import { render } from "./AddRating.vue?vue&type=template&id=acda15ba"
import script from "./AddRating.vue?vue&type=script&lang=js"
export * from "./AddRating.vue?vue&type=script&lang=js"

import "./AddRating.vue?vue&type=style&index=0&id=acda15ba&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__